/**
 * Chargeur du script Google Maps, à la demande.
 *
 * Pas de dépendance ajoutée : `coloc-back` n'embarque aucune bibliothèque
 * cartographique, et en installer une pour une seule carte serait cher payé.
 * Une trentaine de lignes suffisent.
 *
 * Le script n'est chargé qu'à l'ouverture d'un écran qui en a besoin — pas au
 * démarrage du back-office, où il ne servirait à rien.
 *
 * La clé est celle du site public (`coloc-web-*`), restreinte à l'API Maps
 * JavaScript et aux référents des deux surfaces. Une carte interactive va
 * chercher ses tuiles elle-même : contrairement à Places, elle ne peut pas
 * passer par notre proxy.
 */
let chargement: Promise<any> | null = null;

export function chargerGoogleMaps(): Promise<any> {
  if (chargement) return chargement;

  const cle = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!cle) {
    return Promise.reject(new Error('REACT_APP_GOOGLE_MAPS_API_KEY absente'));
  }

  const deja = (window as any).google?.maps;
  if (deja) {
    chargement = Promise.resolve(deja);
    return chargement;
  }

  chargement = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src =
      `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(cle)}` +
      '&language=fr&region=FR';
    script.async = true;
    script.onload = () => resolve((window as any).google.maps);
    script.onerror = () => {
      // Remis à zéro : un échec réseau ne doit pas condamner définitivement
      // la carte pour le reste de la session.
      chargement = null;
      reject(new Error('Chargement de Google Maps impossible'));
    };
    document.head.appendChild(script);
  });

  return chargement;
}
